
import { Component, EventEmitter, forwardRef, Input, Output, Provider, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ConstantConfig } from 'src/app/core/config/constant.config';


const DT_CONTROL_VALUE_ACCESSOR: Provider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CustomDatePickerComponent),
  multi: true,
};

const DT_CONTROL_VALIDATOR:Provider = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => CustomDatePickerComponent),
    multi: true
}

@Component({
  selector: 'app-date-picker',
  templateUrl: './custom-date-picker.component.html',
  providers: [DT_CONTROL_VALUE_ACCESSOR,DT_CONTROL_VALIDATOR],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CustomDatePickerComponent implements ControlValueAccessor {
  @Input()  placeholder:string = 'mm/dd/yyyy';
  @Output() dateSelected: EventEmitter<any> = new EventEmitter();
  @Input() date: string = '';
  @Input() futureDate: boolean = true;
  @Input() pastDate: boolean = true;
  @Input() thirtyDaysLimit:boolean = false;
  @Input() maxDateLimit = 29;
  @Input() minDateLimit = 90;
  @Input() ninetyDaysPastLimit:boolean = false;
  @Input() contractDate:any = '';
  @Input() onlyFutureDate: boolean = false;
  @Input() numberOfYearLimit:number = 0;

  maxDate : any = '';
  minDate : any ={year: 1920, month: 1, day: 1};
  selected!: any;
  disabled = false;
  onChange: any = () => { };
  onTouched: any = () => { };
  onValidationChange: any = () => {};

  private dateInputSubject = new Subject<string>();
  private dateInputSubscription?: Subscription;

  constructor(
    private dtAdapter: NgbDateAdapter<string>,
    private dtParser:NgbDateParserFormatter){
      // if(this.futureDate == false){
      //   let date = new Date();
      //   let todayYear = date.getFullYear()
      //   let todayMonth = date.getMonth()
      //   let todayDate = date.getDate()
      //   this.maxDate = {year: todayYear, month: todayMonth, day: todayDate};
      // }
  }

  ngOnInit(): void {
      this.dateInputSubscription = this.dateInputSubject
      .pipe(debounceTime(1500)) // 1.5 second debounce
      .subscribe(value => {
        this.handleDateInput(value);
      });

      if(this.futureDate == false){
        let date = new Date();
        let todayYear = date.getFullYear();
        let todayMonth = date.getMonth();
        let todayDate = date.getDate();
        this.maxDate = {year: todayYear, month: todayMonth+1, day: todayDate};
      }
      if(this.thirtyDaysLimit == true){
        let date = new Date(new Date().setDate(new Date().getDate() + 29));
        let todayYear = date.getFullYear();
        let todayMonth = date.getMonth();
        let todayDate = date.getDate();
        this.maxDate = {year: todayYear, month: todayMonth+1, day: todayDate};
      }
      if(this.numberOfYearLimit){
        let date = new Date();
        let todayYear = date.getFullYear();
        const effectiveYearLimit=todayYear+this.numberOfYearLimit;
        this.maxDate = {year: effectiveYearLimit, month: 12, day: 31};
      }
      if(this.ninetyDaysPastLimit == true){
        let date = new Date(moment(this.contractDate, 'YYYY-MM-DD').subtract(90,'days').format());
        let todayYear = date.getFullYear();
        let todayMonth = date.getMonth();
        let todayDate = date.getDate();
        this.minDate = {year: todayYear, month: todayMonth+1, day: todayDate};
      }
      if(this.pastDate == false){
        let date = moment(new Date())?.tz(ConstantConfig.SERVER_TIMEZONE);
        let todayYear = date.year();
        let todayMonth = date.month();
        let todayDate = date.date();
        this.minDate = {year: todayYear, month: todayMonth+1, day: todayDate};
      }
      if(this.onlyFutureDate == true){
        let date = moment(new Date())?.tz(ConstantConfig.SERVER_TIMEZONE);
        let todayYear = date.year();
        let todayMonth = date.month();
        let todayDate = date.date();
        this.minDate = {year: todayYear, month: todayMonth+1, day: todayDate+1};
      }
  }

  get value() {
    return this.selected;
  }

  set value(value: any) {
    this.selected = this.dtAdapter.toModel(this.dtAdapter.fromModel(value)) ?? '';

    this.onChange(this.selected);
    this.onValidationChange();
  }

  ngOnChanges(changes: SimpleChanges) {
    const date = changes['date'] || [];
    if (date) {
      if (date['currentValue'] !== date['previousValue'] && date['firstChange']) {
        this.selected = this.dtAdapter.toModel(this.dtAdapter.fromModel(date['currentValue'])) ?? '';
        this.onChange(this.selected);
      }
    }
  }

  onDateSelect(dt: NgbDateStruct) {
    this.onTouched();
    this.selected = this.dtAdapter.toModel(dt) ?? '';
    this.onChange(this.selected);
    this.selected ? this.dateSelected.emit(this.selected) : '';
  }

  writeValue(value: any): void {
    // if(value){
      this.selected = this.dtAdapter.toModel(this.dtAdapter.fromModel(value)) ?? '';
      this.onChange(this.selected);
    // }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  validate(control: AbstractControl): any {
  //  if((control && control.hasValidator(Validators.required))){

  //  }
  }

  registerOnValidatorChange?(fn: () => void): void {
    this.onValidationChange = fn;
  }

  onBlur(status:any){
    if(status == 'INVALID'){
      if(!this.numberOfYearLimit){
        this.selected =  '';
      }
      this.onChange(this.selected);
    }else{
      this.onChange(this.selected);
    }
    this.onTouched();
    this.dateSelected.emit(this.selected);
  }

  reset(): void {
    this.selected = '';
    this.onChange(this.selected);
    this.onTouched();
    this.dateSelected.emit('');
  }

  onModelChange(value: string) {
    this.selected = value;
    this.onChange(this.selected);
    this.onTouched();
    this.dateInputSubject.next(value);
  }

  private handleDateInput(value: string): void {
    const trimmedValue = value?.trim();

    if (!trimmedValue) {
      this.dateSelected.emit('');
      return;
    }

    const m1 = moment(trimmedValue, 'MM/DD/YYYY', true);
    const m2 = moment(trimmedValue, 'YYYY-MM-DD', true);

    const isValid = m1.isValid() || m2.isValid();

    // Extract year from valid moment object
    const parsedDate = m1.isValid() ? m1 : (m2.isValid() ? m2 : null);
    const year = parsedDate?.year() || 0;

    if (!isValid || year > 9999) {
      this.reset(); // Also emits ''
      return;
    }
    if (this.futureDate === false && value) {
      const today = new Date().toISOString().split('T')[0];//today date's format in YYYY-MM-DD
      if (value > today) {
        this.reset();
        return;
      }
    }
    this.selected = trimmedValue;
    this.onChange(this.selected);
    this.dateSelected.emit(this.selected);
  }

  ngOnDestroy(): void {
    this.dateInputSubscription?.unsubscribe();
  }

}
